export default __webpack_public_path__ + "3c80ae5d8eb7fc4e2112ba4ce432ea4d.png";